'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

type Theme = 'official' | 'tmua-fyi';

interface ExamThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

const ExamThemeContext = createContext<ExamThemeContextType | undefined>(undefined);

export function ExamThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>('tmua-fyi');

  return (
    <ExamThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ExamThemeContext.Provider>
  );
}

export function useExamTheme() {
  const context = useContext(ExamThemeContext);
  if (context === undefined) {
    throw new Error('useExamTheme must be used within an ExamThemeProvider');
  }
  return context;
}
